import React, { Component } from "react";

class ModalSizeSelect extends Component {
  constructor(props) {
    super(props);
    this.selectSizeAndStart = this.selectSizeAndStart.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleOverlayClick = this.handleOverlayClick.bind(this);
  }

  selectSizeAndStart(ratio) {
    const { onSelect } = this.props;
    if (onSelect) {
      onSelect(ratio);
    }
  }

  closeModal(e) {
    if (e) {
      e.stopPropagation();
    }

    const { onClose } = this.props;
    if (onClose) {
      onClose();
    }
  }

  handleOverlayClick(e) {
    if (e.target !== e.currentTarget) {
      return;
    }

    this.closeModal(e);
  }

  render() {
    const { isOpen } = this.props;

    if (!isOpen) return null;

    return (
    <>
      <style>
        {
            `
            /* [Popup System] */
            .modal-overlay { display: none; position: fixed; top: 0; left: 0; right: 0; bottom: 0; width: 100%; height: 100%; background: rgba(10, 26, 47, 0.6); z-index: 9999; align-items: center; justify-content: center; }
            .modal-overlay.open { display: flex; }
            .modal-box { background: white; border-radius: 16px; box-shadow: 0 20px 60px rgba(0,0,0,0.3); animation: slideUp 0.3s ease; position: relative; }
            .modal-close-button { position: absolute; top: 16px; right: 16px; width: 24px; height: 24px; border: 0; border-radius: 50%; color: #0e1d32; font-size: 22px; line-height: 32px; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: 0.2s; z-index: 1; padding: 2px; }
            .modal-close-button:hover { background: #e2e8f0; color: #0A1A2F; }
            @keyframes slideUp { from { transform: translateY(20px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }

            /* [Size Selection Popup Specifics] */
            .size-select-grid { display: flex; gap: 20px; margin-top: 24px; }
            .size-card {
                flex: 1; border: 2px solid #e5e7eb; border-radius: 12px; padding: 24px; text-align: center; cursor: pointer; transition: 0.2s;
                display: flex; flex-direction: column; align-items: center; gap: 12px; background: white;
            }
            .size-card:hover { border-color: var(--primary-mint); transform: translateY(-4px); box-shadow: 0 8px 24px rgba(0,0,0,0.05); }
            .size-icon { 
                width: 60px; height: 60px; background: #f1f5f9; border-radius: 12px; 
                display: flex; align-items: center; justify-content: center; margin-bottom: 8px;
            }

            /* Shape Icons */
            .shape-1-1 { width: 30px; height: 30px; border: 3px solid #64748b; border-radius: 4px; }
            .shape-4-5 { width: 24px; height: 36px; border: 3px solid #64748b; border-radius: 4px; }
            .shape-orig { width: 36px; height: 24px; border: 3px solid #64748b; border-radius: 4px; }

            .size-card:hover .shape-1-1, .size-card:hover .shape-4-5, .size-card:hover .shape-orig { border-color: var(--primary-mint); }
            .size-title { font-weight: 700; font-size: 16px; color: var(--deep-navy); }
            .size-desc { font-size: 13px; color: #9ca3af; }
            
            @media (max-width: 800px) {
              .modal-overlay.open {
                align-items: flex-start;
              }
              .modal-box { width: 90% !important; height: auto; max-height: 95%; margin: auto; overflow: hidden; overflow-y: auto;-webkit-overflow-scrolling: touch; word-break: keep-word; }
              .modal-close-button { top: 12px; right: 12px; }
              .size-select-grid { flex-direction: column;}
              .size-card { width: 100%; }
              .modal-title { font-size: 20px !important; }
              .modal-description { font-size: 14px !important; }
            }
            `
        }
      </style>
      <div
        className="modal-overlay open"
        id="modalSizeSelect"
        style={{ zIndex: 10000 }}
        onClick={this.handleOverlayClick}
      >
        <div
          className="modal-box"
          style={{ width: "700px", padding: "40px" }}
          onClick={(e) => e.stopPropagation()}
        >
          <button
            type="button"
            className="modal-close-button"
            onClick={this.closeModal}
            aria-label="닫기"
            title="닫기"
          >
            <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.0704 15.1788C16.1878 15.2973 16.2536 15.4573 16.2536 15.6241C16.2536 15.7909 16.1878 15.9509 16.0704 16.0694C15.9509 16.1849 15.7913 16.2495 15.6251 16.2495C15.4589 16.2495 15.2992 16.1849 15.1798 16.0694L10.0001 10.8819L4.82041 16.0694C4.70095 16.1849 4.54127 16.2495 4.3751 16.2495C4.20892 16.2495 4.04925 16.1849 3.92979 16.0694C3.81242 15.9509 3.74658 15.7909 3.74658 15.6241C3.74658 15.4573 3.81242 15.2973 3.92979 15.1788L9.11728 9.99912L3.92979 4.81943C3.83012 4.698 3.77919 4.54383 3.78689 4.38693C3.7946 4.23002 3.8604 4.08159 3.97148 3.9705C4.08256 3.85942 4.231 3.79362 4.3879 3.78592C4.54481 3.77821 4.69898 3.82914 4.82041 3.92881L10.0001 9.11631L15.1798 3.92881C15.3012 3.82914 15.4554 3.77821 15.6123 3.78592C15.7692 3.79362 15.9176 3.85942 16.0287 3.9705C16.1398 4.08159 16.2056 4.23002 16.2133 4.38693C16.221 4.54383 16.1701 4.698 16.0704 4.81943L10.8829 9.99912L16.0704 15.1788Z" fill="#333333"></path></svg>
          </button>

          <div style={{ textAlign: "center", marginBottom: "30px" }}>
            <h2
              className="modal-title"
              style={{
                fontSize: "24px",
                fontWeight: 800,
                color: "#0A1A2F",
                marginBottom: "8px",
              }}
            >
              콘텐츠 비율 선택
            </h2>
            <p className="modal-description" style={{ color: "#64748b" }}>
              작업을 시작하기 전, 이미지 비율을 선택해주세요.
              {/* <br />
              선택한 비율은 현재 게시물의 모든 이미지에 공통 적용됩니다. */}
            </p>
          </div>

          <div className="size-select-grid">
            <div
              className="size-card"
              onClick={() => this.selectSizeAndStart("1/1")}
            >
              <div className="size-icon">
                <div className="shape-1-1" />
              </div>
              <div className="size-title">1:1 정방형</div>
              <div className="size-desc">
                인스타그램 기본 피드에
                <br />
                최적화된 사이즈
              </div>
            </div>

            <div
              className="size-card"
              onClick={() => this.selectSizeAndStart("4/5")}
            >
              <div className="size-icon">
                <div className="shape-4-5" />
              </div>
              <div className="size-title">4:5 세로형</div>
              <div className="size-desc">
                모바일 화면 점유율이 높은
                <br />
                세로형 사이즈
              </div>
            </div>

            <div
              className="size-card"
              onClick={() => this.selectSizeAndStart("16/9")}
            >
              <div className="size-icon">
                <div className="shape-orig" />
              </div>
              <div className="size-title">16:9 가로형</div>
              <div className="size-desc">
                배너형 콘텐츠에 적합한
                <br />
                가로형 사이즈
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
    );
  }
}

export default ModalSizeSelect;
